module.exports = __webpack_public_path__ + "static/media/apartment4.69d03659.png";